module.exports = __webpack_public_path__ + "static/media/in-person-btn.8dd26826.svg";